<template>
  <div class="classManger">
    <el-card>
      <h1>{{ $route.query.type === "add" ? "添加" : "编辑" }}报考指南</h1>
      <el-row>
        <el-form
        :model="ruleForm"
        label-position="left"
        :inline="true"
        :rules="rules"
        ref="ruleForm"
        label-width="80px"
        class="demo-ruleForm"
        style="width: 100%"
      >
      <el-col :span="7">
        <el-form-item label="指南名称" prop="guideName">
          <el-input style="width: 100%" v-model="ruleForm.guideName"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="7">
        <el-form-item label="指南封面" prop="logo">
          <el-upload
            class="self-uploader"
            :action="fileAction"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
            <img v-if="ruleForm.logo" :src="ruleForm.logo" class="avatar">
            <i v-else class="el-icon-plus self-uploader-icon"></i>
          </el-upload>
          <span style="color: #a5a5a5">封面尺寸: 282*210 px ;图片格式: png jpg jpeg;图片大小 ≤2MB</span>
        </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="" style="margin-left: 150px">
            <el-switch v-model="ruleForm.isAdd"></el-switch>
            <span style="color: #a5a5a5">上架后将会展示在学员端</span>
          </el-form-item>
        </el-col>
        <el-form-item>
          <!--   <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
    <el-button @click="resetForm('ruleForm')">重置</el-button>  @tab-click="handleClick"-->
        </el-form-item>
      </el-form>
      </el-row>
      
      <el-tabs v-model="activeName">
        <el-tab-pane label="考前须知" name="testInstructions"
          ><test-instructions
            :subjectGuideItems="subjectGuideItems"
            @saveData="saveData"
            @change="change"
            :type="$route.query.type"
            :com="'考前须知'"
            :value="queryData.subjectGuideItems[0]"
        /></el-tab-pane>
        <el-tab-pane label="考试报名" name="testRegistration"
          ><test-registration
            :subjectGuideItems="subjectGuideItems"
            @saveData="saveData"
            @change="change"
            :type="$route.query.type"
            :com="'考试报名'"
            :value="queryData.subjectGuideItems[1]"
        /></el-tab-pane>
        <el-tab-pane label="准考证打印" name="printYourAdmissionTicket"
          ><print-your-admission-ticket
            :subjectGuideItems="subjectGuideItems"
            @saveData="saveData"
            @change="change"
            :type="$route.query.type"
            :com="'准考证打印'"
            :value="queryData.subjectGuideItems[2]"
        /></el-tab-pane>
        <el-tab-pane label="考试详情" name="detailsTheTest"
          ><details-the-test
            :subjectGuideItems="subjectGuideItems"
            @saveData="saveData"
            @change="change"
            :type="$route.query.type"
            :com="'考试详情'"
            :value="queryData.subjectGuideItems[3]"
        /></el-tab-pane>
        <el-tab-pane label="成绩查询" name="resultsQuery"
          ><results-query
            :subjectGuideItems="subjectGuideItems"
            @saveData="saveData"
            @change="change"
            :type="$route.query.type"
            :com="'成绩查询'"
            :value="queryData.subjectGuideItems[4]"
        /></el-tab-pane>
        <el-tab-pane label="证书领取" name="certificateToReceive"
          ><certificate-to-receive
            :subjectGuideItems="subjectGuideItems"
            @saveData="saveData"
            @change="change"
            :type="$route.query.type"
            :com="'证书领取'"
            :value="queryData.subjectGuideItems[5]"
        /></el-tab-pane>
        <el-tab-pane label="常见问题" name="faq">
          <faq
            :subjectGuideItems="subjectGuideItems"
            @saveData="saveData"
            @change="change"
            :type="$route.query.type"
            :com="'常见问题'"
            :value="queryData.subjectGuideItems[6]"
          />
        </el-tab-pane>
        <el-tab-pane label="猜你喜欢" name="guessYouLike">
          <guess-you-like
            :subjectGuideItems="subjectGuideItems"
            @saveData="saveData"
            @change="change"
            :type="$route.query.type"
            :com="'猜你喜欢'"
            :value="queryData.subjectGuideItems[7]"
          />
        </el-tab-pane>
      </el-tabs>
      <div style="clear: both"></div>
    </el-card>
  </div>
</template>

<script>
//import drawerDetail from "@/components/drawerDetail.vue";
import { Loading } from "element-ui";
import testInstructions from "./module/testInstructions.vue";
import testRegistration from "./module/testRegistration.vue";
import printYourAdmissionTicket from "./module/printYourAdmissionTicket.vue";
import detailsTheTest from "./module/detailsTheTest.vue";
import faq from "./module/faq.vue";
import resultsQuery from "./module/resultsQuery.vue";
import certificateToReceive from "./module/certificateToReceive.vue";
import guessYouLike from "./module/guessYouLike.vue";
export default {
  components: {
    testInstructions,
    testRegistration,
    printYourAdmissionTicket,
    faq,
    detailsTheTest,
    resultsQuery,
    certificateToReceive,
    guessYouLike,
  },
  data() {
    return {
      id: "",
      activeName: "",
      comList: [],
      loading: undefined, //表格是否加载中
      loading2: undefined, //表格是否加载中
      inp: "", //输入框绑定的值
      queryData: {},
      subjectGuideItems: [],

      ruleForm: {
        guideName: "",
        isAdd: false,
        logo:''
      },

      rules: {
        guideName: [
          {
            required: true,
            message: "请输入指南名称",
            trigger: "change",
          },
        ],
        logo:[{
          required: true,
            message: "请上传指南封面",
            trigger: "change",
        }]
      },

      imageUrl:'',
      fileAction: `${process.env.BASE_URL}/system/uploadFile`
    };
  },
  methods: {
handleAvatarSuccess(res,file){
  console.log(res,file);
this.ruleForm.logo = res.data;
},
beforeAvatarUpload(file){
  const isJPG = file.type === 'image/jpeg';
  const isPNG = file.type === 'image/png';
  const isLt2M = file.size / 1024 / 1024 < 2;
  const valid = isJPG || isPNG
  if (!valid) {
    this.$message.error('上传封面应是 JPG / PNG 格式!');
  }
  if (!isLt2M) {
    this.$message.error('上传头像图片大小不能超过 2MB!');
  }
  return valid && isLt2M;
},

    change(obj) {
      const titleList = [
        "考前须知",
        "考试报名",
        "准考证打印",
        "考试详情",
        "成绩查询",
        "证书领取",
        "常见问题",
        "猜你喜欢",
      ];
      const index = titleList.findIndex((item) => item === obj.type);

      let list = obj.subjectGuideItemDetails;
      if (Array.isArray(list)) {
        for (let i = 0; i < list.length; i++) {
          let item1 = list[i];

          delete item1.id;
        }
      }
      this.queryData.subjectGuideItems[index] = obj;
    },
    saveData() {
      this.$refs.ruleForm.validate(valid=>{
        if(valid){
          const type = this.$route.query.type;
          console.log("获取数据", this.queryData);
          this.loading = Loading.service({
            lock: true,
            text: "保存数据。。",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });

          this.api.guideEx[
            type === "add" ? "addSubjectGuide" : "updateSubjectGuide"
          ](Object.assign(this.queryData, { id: this.$route.query.id }))
            .then((res) => {
              if (res.success) {
                this.$message.success(res.message);
                this.$router.replace({ path: "/registerGuide" });
              } else {
                this.$message.error(res.message);
              }
            })
            .finally(() => {
              this.loading.close();
            });
        }
      })
      // const type = this.$route.query.type;
      // console.log("获取数据", this.queryData);
      // if (!this.queryData.guideName)
      //   return this.$message.warning("请填写指南名称");
      // // if(){}
      // this.loading = Loading.service({
      //   lock: true,
      //   text: "保存数据。。",
      //   spinner: "el-icon-loading",
      //   background: "rgba(0, 0, 0, 0.7)",
      // });

      // this.api.guideEx[
      //   type === "add" ? "addSubjectGuide" : "updateSubjectGuide"
      // ](Object.assign(this.queryData, { id: this.$route.query.id }))
      //   .then((res) => {
      //     if (res.success) {
      //       this.$message.success(res.message);
      //       this.$router.replace({ path: "/registerGuide" });
      //     } else {
      //       this.$message.error(res.message);
      //     }
      //   })
      //   .finally(() => {
      //     this.loading.close();
      //   });
    },

    //saveTotalPage() {},
    updateSubjectGuide() {
      if (this.id) {
        console.log("log", this.id);
        this.api.guideEx
          .guideOnOrOff({ id: this.id, isAdd: this.ruleForm.isAdd ? 1 : -1 })
          .then((res) => {
            if (!res.message) {
              this.$message.error(res.message);
            }
          });
      }
    },
    initData() {
      const type = this.$route.query.type;
      const dictionaryId = this.$route.query.dictionaryId || "";
      const id = this.$route.query.id || "";
      this.id = id;
      if (type === "add") {
        this.$nextTick(() => {
          this.queryData = {
            guideName: "",
            dictionaryId: dictionaryId, //上个接口返回的类别的id
            isAdd: 1,
            subjectGuideItems: [
              {
                type: "考前须知",
                subjectGuideItemDetails: [
                  /*  {
                    title: "考试介绍",
                    content: "12",
                  },
                  { title: "科目", content: "", anotherContent: 0 }, */
                ],
              },
              {
                type: "考试报名",
                subjectGuideItemDetails: [
                  {
                    title: "报名条件",
                    content: "",
                  },
                  {
                    title: "报名时间",
                    content: "",
                  },
                  {
                    title: "报名流程",
                    content: "",
                  },
                ],
              },
              {
                type: "准考证打印",
                subjectGuideItemDetails: [
                  {
                    title: "准考证打印时间",
                    content: "",
                  },
                  {
                    title: "准考证打印方法",
                    content: "",
                  },
                ],
              },
              {
                type: "考试详情",
                subjectGuideItemDetails: [
                  {
                    title: "考试时间",
                    content: "",
                    anotherContent: "",
                  },
                  {
                    title: "考试方式",
                    content: "",
                  },
                  {
                    title: "考试题型",
                    content: "",
                  },
                ],
              },
              {
                type: "成绩查询",
                subjectGuideItemDetails: [
                  {
                    title: "成绩查询入口",
                    content: "",
                  },
                  {
                    title: "合格标准",
                    content: "",
                  },
                ],
              },
              {
                type: "证书领取",
                subjectGuideItemDetails: [
                  {
                    title: "证书领取方式",
                    content: "",
                  },
                  {
                    title: "证书样式",
                    content: "",
                  },
                ],
              },
              {
                type: "常见问题",
                subjectGuideItemDetails: [{ title: "", content: "" }],
              },
              {
                type: "猜你喜欢",
                subjectGuideItemDetails: [],
              },
            ],
          };
        });

        console.log("传的querydata", this.queryData);
      } else if (type === "edit") {
        this.loading2 = Loading.service({
          lock: true,
          text: "加载数据。。",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        this.api.guideEx
          .getSubjectGuide(id)
          .then((result) => {
            if (result.success) {
              //this.queryData = result.data;
              this.subjectGuideItems = result.data.subjectGuideItems;
              this.ruleForm.guideName = result.data.guideName;
              this.ruleForm.logo = result.data.logo
              this.ruleForm.isAdd = result.data.isAdd == 1 ? true : false;
              this.queryData.dictionaryId = dictionaryId;
              if (true) {
                // this.queryData.subjectGuideItems = [...new Array(8).fill({name:1})];
                this.$set(this.queryData, "subjectGuideItems", [
                  {
                    type: "考前须知",
                    subjectGuideItemDetails: [
                      {
                        title: "考试介绍",
                        content: "",
                      },
                    ],
                  },
                  {
                    type: "考试报名",
                    subjectGuideItemDetails: [
                      {
                        title: "报名条件",
                        content: "",
                      },
                      {
                        title: "报名时间",
                        content: "",
                      },
                      {
                        title: "报名流程",
                        content: "",
                      },
                    ],
                  },
                  {
                    type: "准考证打印",
                    subjectGuideItemDetails: [
                      {
                        title: "准考证打印时间",
                        content: "",
                      },
                      {
                        title: "准考证打印方法",
                        content: "",
                      },
                    ],
                  },
                  {
                    type: "考试详情",
                    subjectGuideItemDetails: [
                      {
                        title: "考试时间",
                        content: "",
                        anotherContent: "",
                      },
                      {
                        title: "考试方式",
                        content: "",
                      },
                      {
                        title: "考试题型",
                        content: "",
                      },
                    ],
                  },
                  {
                    type: "成绩查询",
                    subjectGuideItemDetails: [
                      {
                        title: "成绩查询入口",
                        content: "",
                      },
                      {
                        title: "合格标准",
                        content: "",
                      },
                    ],
                  },
                  {
                    type: "证书领取",
                    subjectGuideItemDetails: [
                      {
                        title: "证书领取方式",
                        content: "",
                      },
                      {
                        title: "证书样式",
                        content: "",
                      },
                    ],
                  },
                  {
                    type: "常见问题",
                    subjectGuideItemDetails: [],
                  },
                  {
                    type: "猜你喜欢",
                    subjectGuideItemDetails: [],
                  },
                ]);
              }

              //  console.log("this.queryData", this.queryData);
            }
          })
          .finally(() => {
            this.loading2.close();
          });
      }
    },
  },
  watch: {
    ruleForm: {
      handler(val, old) {
        this.queryData.isAdd = val.isAdd ? 1 : -1;
        this.queryData.guideName = val.guideName;
        this.queryData.logo = val.logo;
        console.log("querydata", this.queryData);
      },
      deep: true,
      immediate: true,
    },
    "ruleForm.isAdd": {
      handler(val) {
        this.updateSubjectGuide();
        console.log(val);
      },
      deep: true,
      //immediate: true,
    },
  },
  created() {
    this.initData();
  },
  mounted() {
    this.$nextTick(() => {
      this.activeName = "testInstructions";
    });
  },
  beforeMount() {
    window.sessionStorage.removeItem("anotherContent");
  },
};
</script>
<style scoped>
.sidebar {
  width: 245px !important;
  border-radius: 4px;
  overflow: auto;
  background: #fff;
}
.sidebarRight {
  padding: 0px 20px !important;
}

.sidebar .title,
.sidebarRight .title {
  height: 50px;
  line-height: 50px;
  padding-left: 20px;
  border-bottom: 1px solid #e5ecf0;
}

.sidebarRight .search {
  background: #66b1ff !important;
  border: 0;
  outline: none;
  border-radius: 0;
  height: 40px;
  color: white !important;
}

.classManger .caret-wrapper {
  position: absolute;
  right: 0;
  top: -5px;
}
.table_bottom {
  margin: 20px 0;
}
.left-top-bottom {
  float: right;
  color: #4d94ff;
  font-weight: 600;
  margin-left: 10px;
  margin-top: 2px;
}
.campusManage-search {
  padding: 0px 10px;
}
.campusManage-tree {
  margin-top: 10px;
}
.span-ellipsis {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
}

.avatar-uploader .el-upload {
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 120px;
    height: 90px;
    line-height: 90px;
    border: none;
  }
  .self-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .self-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 90px;
    line-height: 90px;
    text-align: center;
    border: 1px dashed #d9d9d9;
    border-radius: 8px;
  }
  .avatar {
    width: 120px;
    height: 90px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/addGuide/index.vue